export default __webpack_public_path__ + "static/media/melih2.9d8a837d.png";